import {useIonActionSheet} from "@ionic/react";

export function withIonActionSheet(Component) {
    return function WrappedComponent(props) {
        const [presentActionSheet] = useIonActionSheet();
        return <Component {...props} presentActionSheet={presentActionSheet} />;
    }
}